import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text, Image } from 'rebass/styled-components';
import { X } from 'lucide-react';
import IconStars from '../../../../assets/icon-stars.svg';

export const GrowListAgentHeader = ({ listName, onClose }) => (
  <Flex
    sx={{
      height: '64px',
      borderBottom: '1px solid',
      borderColor: 'border.subtle',
      alignItems: 'center',
      justifyContent: 'space-between',
      px: '16px',
      backgroundColor: 'white',
    }}
  >
    {/* Left: Title with icon */}
    <Flex sx={{ alignItems: 'center', gap: '8px', flex: 1, minWidth: 0 }}>
      <Image src={IconStars} alt="AI Agent" width="32px" height="32px" sx={{ flexShrink: 0 }} />
      <Text
        sx={{
          fontSize: '16px',
          fontWeight: 600,
          color: 'text.dark',
          letterSpacing: '-0.5px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        AI Agent to grow &quot;{listName}&quot;
      </Text>
    </Flex>

    {/* Right: Close button */}
    <Flex sx={{ flex: 1, justifyContent: 'flex-end' }}>
      <Box
        as="button"
        onClick={onClose}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '32px',
          height: '32px',
          border: 'none',
          background: 'transparent',
          cursor: 'pointer',
          color: 'text.subtle',
          borderRadius: '4px',
          flexShrink: 0,
          '&:hover': {
            backgroundColor: 'neutral.50',
            color: 'text.main',
          },
        }}
      >
        <Box as={X} sx={{ width: '16px', height: '16px' }} />
      </Box>
    </Flex>
  </Flex>
);

GrowListAgentHeader.propTypes = {
  listName: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
